import { render, staticRenderFns } from "./FollowUpModal.vue?vue&type=template&id=7090f60e&scoped=true"
import script from "./FollowUpModal.vue?vue&type=script&lang=ts"
export * from "./FollowUpModal.vue?vue&type=script&lang=ts"
import style0 from "./FollowUpModal.vue?vue&type=style&index=0&id=7090f60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7090f60e",
  null
  
)

export default component.exports